<template>
  <div class="smart-paper-page">
    <el-card class="filter-card">
      <div slot="header" class="card-header">
        <div class="card-header-left"><i class="el-icon-edit"></i><span>智能选题组卷</span>
          <el-divider direction="vertical"/><span class="header-sub">从已清洗知识库按命中率选题（不依赖实时AI）</span></div>
      </div>
      <el-form :inline="true" :model="query" class="filter-form">
        <el-form-item label="目标单词ID" required>
          <el-input v-model="wordIdsText" type="textarea" :rows="2" placeholder="逗号或空格分隔，如：101,102,103"
            style="width:320px"/>
        </el-form-item>
        <el-form-item label="题型" required>
          <el-select v-model="query.questionType" placeholder="请选择" style="width:160px">
            <el-option v-for="(name,val) in QUESTION_TYPE_MAP" :key="val" :label="name" :value="Number(val)"/>
          </el-select>
        </el-form-item>
        <el-form-item label="需要数量">
          <el-input-number v-model="query.needCount" :min="1" :max="50"/>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleSearch" :loading="tableLoading">检索候选</el-button>
          <el-button icon="el-icon-refresh" @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card class="table-card">
      <div slot="header" class="card-header">
        <div class="card-header-left"><span>候选题目</span>
          <span class="total-badge">命中 {{ total }} 道（按命中单词数降序）</span></div>
      </div>
      <el-table :data="list" border stripe v-loading="tableLoading" element-loading-text="加载中...">
        <el-table-column type="index" label="序号" width="70" align="center"/>
        <el-table-column prop="content" label="题目内容" min-width="260" show-overflow-tooltip/>
        <el-table-column prop="questionType" label="题型" width="120" align="center">
          <template slot-scope="scope">{{ QUESTION_TYPE_MAP[scope.row.questionType] || scope.row.questionType }}</template>
        </el-table-column>
        <el-table-column label="命中单词数" width="120" align="center">
          <template slot-scope="scope">{{ hitCount(scope.row) }}</template>
        </el-table-column>
        <el-table-column prop="reviewStatus" label="诊断" width="110" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.reviewStatus===2?'success':'primary'" size="small" effect="plain">
              {{ scope.row.reviewStatus===2?'老师已诊断':'AI已诊断' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="usageCount" label="使用次数" width="90" align="center"/>
      </el-table>
      <el-alert v-if="list.length && list.length < query.needCount" type="warning" :closable="false"
        :title="`题库该题量不足：仅检索到 ${list.length} 道，目标 ${query.needCount} 道，请补充知识库或调整数量`" style="margin-top:12px"/>
    </el-card>
  </div>
</template>

<script>
import { reqSelectForManualPaper } from '@/api/education/questionLibrary'

export default {
  name: 'SmartPaper',
  data() {
    return {
      QUESTION_TYPE_MAP: {
        1: '高频生词表', 2: 'SuperMemo速记', 3: '例句练习表', 4: '好词好句',
        5: '语境语感训练', 6: '选词填空', 7: '短文填空', 8: '任务型阅读',
        9: '完形填空', 10: '补全对话'
      },
      wordIdsText: '',
      query: { questionType: null, needCount: 5 },
      list: [],
      total: 0,
      tableLoading: false,
      targetSet: []
    }
  },
  methods: {
    parseWordIds() {
      const arr = (this.wordIdsText || '').split(/[\s,，]+/).map(s => s.trim()).filter(s => s)
      return arr.map(Number).filter(n => !isNaN(n))
    },
    async handleSearch() {
      const wordIds = this.parseWordIds()
      this.targetSet = wordIds
      if (!wordIds.length) { this.$message.warning('请输入目标单词ID'); return }
      if (!this.query.questionType) { this.$message.warning('请选择题型'); return }
      this.tableLoading = true
      try {
        this.list = await reqSelectForManualPaper(wordIds, this.query.questionType)
        this.total = this.list.length
        if (!this.total) this.$message.info('知识库中暂无匹配题目')
      } catch (e) { this.$message.error('检索失败'); console.error(e) }
      finally { this.tableLoading = false }
    },
    handleReset() {
      this.wordIdsText = ''
      this.query = { questionType: null, needCount: 5 }
      this.list = []
      this.total = 0
    },
    hitCount(row) {
      if (!row.coveredWordIds) return 0
      try {
        const ids = JSON.parse(row.coveredWordIds)
        return ids.filter(id => this.targetSet.includes(id)).length
      } catch (e) { return 0 }
    }
  }
}
</script>

<style lang="scss" scoped>
.smart-paper-page { padding: 16px; }
.card-header { display: flex; justify-content: space-between; align-items: center; }
.header-sub { color: #909399; font-size: 12px; }
.total-badge { margin-left: 12px; color: #606266; font-size: 13px; }
</style>
